import { render } from "./TheForm.vue?vue&type=template&id=404dfd1a"
import script from "./TheForm.vue?vue&type=script&lang=js"
export * from "./TheForm.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__